import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';

const initialState = {
	currentOpenDrawer: '',
	loading: false,
	allJobsList: [],
	pagination: {
		page: 1,
		limit: 10,
		totalPages: 0,
		totalResults: 0,
	},
	drawerVaues: {
		VIEW_JOBS_DRAWER: 'VIEW_JOBS_DRAWER',
		FILTER_JOBS_DRAWRE: 'FILTER_JOBS_DRAWRE',
	},
};

export const fetchAllJobs = createAsyncThunk('jobsManagement/fetAlljobs', async (options, { rejectWithValue }) => {
	try {
		const query = new URLSearchParams(options).toString();

		const response = await axiosInstance.get(`job/admin?${query}`);

		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const editJobData = createAsyncThunk('jobsManagement/deleteAJob', async ({ data, id }, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosInstance.patch(`/job/admin/${id}`, data);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
			};

			dispatch(fetchAllJobs(options));

			return response;
		}

		return rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const deleteAJob = createAsyncThunk('jobsManagement/deleteAJob', async (id, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosInstance.delete(`job/${id}`);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
			};

			dispatch(fetchAllJobs(options));
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const jobsManagementSlice = createSlice({
	name: 'jobsManagement',
	initialState,
	reducers: {
		setCurrentOpenDraverValueTo: (state, action) => {
			state.currentOpenDrawer = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllJobs.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchAllJobs.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.allJobsList = payload.result.data;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(fetchAllJobs.rejected, (state) => {
				state.loading = false;
			});
	},
});

export const { setCurrentOpenDraverValueTo } = jobsManagementSlice.actions;

export default jobsManagementSlice.reducer;
